import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import Content from '../../../layout/Content';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { PRICING_PROFILE_MASSIVE_UPDATE_PATH } from '../../../../config/paths';
import Loader from '../../../common/Loader';

import NoDataResource from '../../../common/resource/NoDataResource';
import PricingProfileDateScheduleBasicInformationResource from './resource/PricingProfileMassiveUpdateBasicInformationResource';
import {
  clearPricingProfileMassiveUpdate,
  getPricingProfileMassiveUpdate,
} from '../../../../actions';

const PricingProfileMassiveUpdate = ({
  breadcrumbs,
  loading,
  match: {
    params: { id: pricingProfileMassiveUpdateId },
  },
  dispatchGetPricingProfileMassiveUpdate,
  dispatchClearPricingProfileMassiveUpdate,
  pricingProfileMassiveUpdate,
}) => {
  useLayoutEffect(() => {
    dispatchGetPricingProfileMassiveUpdate({ pricingProfileMassiveUpdateId });
    return () => dispatchClearPricingProfileMassiveUpdate();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (pricingProfileMassiveUpdate.isEmpty())
    content = (
      <NoDataResource returnPage={PRICING_PROFILE_MASSIVE_UPDATE_PATH} />
    );
  else {
    const pricingProfileMassiveUpdateJson = pricingProfileMassiveUpdate.toJS();
    content = (
      <PricingProfileDateScheduleBasicInformationResource
        {...pricingProfileMassiveUpdateJson}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Tarifario"
      content={content}
    />
  );
};

PricingProfileMassiveUpdate.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetPricingProfileMassiveUpdate: PropTypes.func.isRequired,
  dispatchClearPricingProfileMassiveUpdate: PropTypes.func.isRequired,
  pricingProfileMassiveUpdate: PropTypes.instanceOf(Immutable.Map).isRequired,
};

PricingProfileMassiveUpdate.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearPricingProfileMassiveUpdate: clearPricingProfileMassiveUpdate,
  dispatchGetPricingProfileMassiveUpdate: getPricingProfileMassiveUpdate,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Actualizaciones Masivas de Perfiles de Precio',
      href: PRICING_PROFILE_MASSIVE_UPDATE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  pricingProfileMassiveUpdate: SalesUnit.PricingProfileMassiveUpdate.getIn([
    'current',
    'content',
  ]),
  loading: !SalesUnit.PricingProfileMassiveUpdate.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricingProfileMassiveUpdate);
